import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['streetAddress']
  connect() {
    this.fullAddress();
  }

  fullAddress() {
    var input = this.streetAddressTarget
    if (input) {
      var autocomplete = new google.maps.places.Autocomplete(input);
      google.maps.event.addDomListener(input, 'onClick', function(event) {
        if (event.keyCode === 13) {
          return event.preventDefault();
        }
      });
    }
  }
}
